import { Badge, Button, Tag, Tooltip, message, Input, Modal, } from "antd";
import {
  EditFilled,
  CheckCircleFilled,
  CloseCircleFilled,
  CheckCircleOutlined
} from "@ant-design/icons";
import { MailOutlined, PhoneOutlined, PlusOutlined } from "@ant-design/icons";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import AdsClickOutlinedIcon from "@mui/icons-material/AdsClickOutlined";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import MarkunreadMailboxOutlinedIcon from "@mui/icons-material/MarkunreadMailboxOutlined";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import ScheduleSendOutlinedIcon from "@mui/icons-material/ScheduleSendOutlined";
import Typography from "app/shared/Typography";
import moment from "moment";
import { CheckBox } from "@mui/icons-material";
import { createRoot } from 'react-dom/client';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';



// Format timestamp into readable date
const formatDate = (timestamp) => {
  if (!timestamp) return "N/A";
  return moment.unix(timestamp).format("DD-MM-YYYY, hh:mm A"); // Fix: Corrected minute formatting
};

const handleInvoiceView = async (blobUrls) => {
  const newTabs = blobUrls.map(() => window.open("", "_blank"));

  try {
    const response = await fetch(
      "https://stage-apiplatform.finkraftai.com/api/storage/objects/azure/file/url",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ blobUrls }),
      }
    );

    const data = await response.json();
    console.log("data", data);

    if (data && Array.isArray(data.signedUrls)) {
      data.signedUrls.forEach((url, index) => {
        if (newTabs[index]) {
          newTabs[index].location.href = url;
        }
      });
    } else {
      console.error("No URLs returned from API", data);
    }
  } catch (error) {
    console.error("Failed to fetch invoice URLs:", error);
  }
};
const handleResendMail = async (rowData) => {
  try {
    const response = await fetch("https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/manualSingleMailTrigger", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rowData),
    });

    const result = await response.json();
    if (response.ok) {
      message.success("Mail triggered successfully");
    } else {
      message.error(result?.message || "Something went wrong");
    }
  } catch (error) {
    console.error("Error triggering mail:", error);
    message.error("Failed to trigger mail");
  }
};



const colorOfEmailEvent = {
  processed: "#007BFF",
  delivered: "#007BFF",
  open: "#28A745",
  click: "#FFC107",
  bounce: "#E74C3C",
  dropped: "#E74C3C",
  spammed: "#E74C3C",
  deffered: "#E74C3C",
};

const EVENT_ICON_MAP = {
  processed: (color) => <CheckOutlinedIcon style={{ fontSize: 18, color }} />,
  delivered: (color) => <DoneAllOutlinedIcon style={{ fontSize: 18, color }} />,
  open: (color) => <DraftsOutlinedIcon style={{ fontSize: 18, color }} />,
  click: (color) => <AdsClickOutlinedIcon style={{ fontSize: 18, color }} />,
  bounce: (color) => <CancelOutlinedIcon style={{ fontSize: 18, color }} />,
  dropped: (color) => (
    <MarkunreadMailboxOutlinedIcon style={{ fontSize: 18, color }} />
  ),
  spammed: (color) => (
    <PrivacyTipOutlinedIcon style={{ fontSize: 18, color }} />
  ),
  deffered: (color) => (
    <ScheduleSendOutlinedIcon style={{ fontSize: 18, color }} />
  ),
};


const handleRenderEmailEvents = (params) => {
  console.log("********************");
  console.log(params, "params");
  let emailLogs = params;
  console.log(emailLogs, "email logs check");

  if (params?.node?.group) {
    return null;
  }




  return (
    <div style={{ display: "flex", gap: 8 }}>
      {emailLogs?.map((log, index) => (
        <Tooltip
          key={index}
          placement="bottom"
          title={
            <div
              style={{
                maxHeight: 200,
                maxWidth: 350,
                overflowY: "auto",
                padding: 8,
                backgroundColor: "#1c1c1c",
                borderRadius: 8,
              }}
            >
              <Typography style={{ color: "white", marginBottom: 8 }}>
                <strong></strong> {log.log_type || "No Log Type"}
              </Typography>
              {/* {log.events && log.events.length > 0 ? (
                (() => {
                  const latestEventsMap = new Map();
                  log.events.forEach((event) => {
                    const eventType = event.event || "unknown";
                    if (!latestEventsMap.has(eventType)) {
                      latestEventsMap.set(eventType, event);
                    } else {
                      const existing = latestEventsMap.get(eventType);
                      if (event.timestamp > existing.timestamp) {
                        latestEventsMap.set(eventType, event);
                      }
                    }
                  });

                  const latestEvents = Array.from(latestEventsMap.values());
                  return latestEvents.map((event, i) => {
                    const eventType = event.event || "unknown";
                    const eventColor = colorOfEmailEvent[eventType] || "#A0A0A0";
                    const EventIcon = EVENT_ICON_MAP[eventType];

                    return (
                      <Tag
                        key={i}
                        style={{
                          fontSize: 10,
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          whiteSpace: "normal",
                          wordBreak: "break-word",
                          marginBottom: 4,
                        }}
                      >
                        {EventIcon ? EventIcon(eventColor) : null}
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <span style={{ color: "#000", fontWeight: 500 }}>
                            ✉️ {event.email || "No Email"}
                          </span>
                          <span>
                            <strong
                              style={{
                                color: event.event === "bounce" ? "red" : "#000",
                              }}
                            >
                              {event.event}
                            </strong>{" "}
                            at {formatDate(event.timestamp)}
                          </span>
                        </div>
                      </Tag>


                    );
                  });
                })()
              ) :
                <div style={{ color: "#999", fontSize: 12 }}>
                  No events available
                </div>
              } */}
              {log.events && log.events.length > 0 ? (
                log.events.map((event, i) => {
                  const eventType = event.event || "unknown";
                  const eventColor = colorOfEmailEvent[eventType] || "#A0A0A0";
                  const EventIcon = EVENT_ICON_MAP[eventType];

                  return (
                    <Tag
                      key={i}
                      style={{
                        fontSize: 10,
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        marginBottom: 4,
                      }}
                    >
                      {EventIcon ? EventIcon(eventColor) : null}
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <span style={{ color: "#000", fontWeight: 500 }}>
                          ✉️ {event.email || "No Email"}
                        </span>
                        <span>
                          <strong
                            style={{
                              color: event.event === "bounce" ? "red" : "#000",
                            }}
                          >
                            {event.event}
                          </strong>{" "}
                          at {formatDate(event.timestamp)}
                        </span>
                      </div>
                    </Tag>
                  );
                })
              ) : (
                <div style={{ color: "#999", fontSize: 12 }}>
                  No events available
                </div>
              )}

            </div>
          }
        >
          <Badge
            count={index + 1}
            style={{
              backgroundColor: "#0A8394",
              color: "white",
              cursor: "pointer",
              padding: "6px",
              borderRadius: "50%",
              minWidth: "22px",
              height: "22px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "12px",
              fontWeight: "bold",
            }}
          />
        </Tooltip>
      ))}
    </div>
  );
};

const FollowUpStatusRenderer = ({ value }) => {
  const isEmpty = !value;
  const displayValue = isEmpty ? 'Select status' : value;

  return (
    <span style={{ color: isEmpty ? '#aaa' : 'inherit' }}>
      {displayValue} <span style={{ color: '#999' }}>▼</span>
    </span>
  );
}


export const 
HOTEL_FOLLOWUP_COLUMN_DEFS = (props) => {
  console.log(props, "props check")
  return [
    {
      headerName: 'Select',
      field: 'id', // or any key
      checkboxSelection: (params) => {
        // Only show checkbox for child rows under a group
        return !params.node.group && params.node.parent != null;
      },
      headerCheckboxSelection: false,
      width: 100,
      pinned: 'left',
    },
    {
      headerName: "Mail Config Status",
      field: "mailConfigStauts",
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["RUNNING", "EMAILREQUIRED", "EMAIL_REQUIRED"],
      },
      enableRowGroup: true,
      cellRenderer: (params) => {
        console.log("parmas:");
        if (params.node.group || !params?.data?.mailConfigStauts) return null;

        const status = params.data.mailConfigStauts;
        const color = status === "RUNNING" ? "green" : "red";

        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      headerName: "Email Booking ID",
      field: "email_bookingId",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Booking Client ID",
      field: "booking_client_id",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },

    {
      headerName: "Entity Name",
      field: "company_name",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Template",
      width: 200,
      cellRenderer: (params) => {
        if (params.node.group || !params.data) return null;

        return (
          <Button
            type="primary"
            onClick={() => {
              props.setModalType("TEMPLATE");
              props.setModalData(params.data);
              props.setIsModalVisible(true);
            }}
            size="small"
          >
            Show Template
          </Button>
        );
      },
    },

    // {
    //   headerName: "Hotel Contact Email",
    //   field: "email_hotel_contact_email",
    //   enableRowGroup: true,
    //   width: 300,
    //   filter: "agTextColumnFilter",
    //   cellRenderer: (params) => {
    //     if (params.node.group) {
    //       return null;
    //     }
    //     const emails = params.value; // Assuming params.value is an array of emails
    //     const visibleEmail = emails?.[0]; // Show only the first email
    //     const remainingCount = emails?.length > 1 ? emails.length - 1 : 0; // Count remaining emails

    //     return (
    //       <div
    //         style={{
    //           height: "100%",
    //           width: "100%",
    //           display: "flex",
    //           alignItems: "center",
    //           gap: "5px",
    //           flexWrap: "wrap",
    //         }}
    //       >
    //         {emails && Array.isArray(emails) && emails.length > 0 ? (
    //           <>
    //             <Tag icon={<MailOutlined />}>{visibleEmail}</Tag>

    //             {remainingCount > 0 && (
    //               <Tooltip
    //                 title={emails.slice(1).map((email, idx) => (
    //                   <div key={idx}>{email}</div>
    //                 ))}
    //               >
    //                 <span style={{ color: "#1890ff", cursor: "pointer" }}>
    //                   +{remainingCount}
    //                 </span>
    //               </Tooltip>
    //             )}

    //             <EditFilled
    //               style={{ cursor: "pointer", marginLeft: "5px" }}
    //               onClick={() => props.openEmailModal(params.data)}
    //             />
    //           </>
    //         ) : (
    //           <Tag
    //             style={{ cursor: "pointer" }}
    //             onClick={() => props.openEmailModal(params.data)}
    //           >
    //             Add Email
    //           </Tag>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      headerName: "Hotel Contact Email",
      field: "email_hotel_contact_email",
      enableRowGroup: true,
      width: 300,
      filter: "agNumberColumnFilter",
      filterParams: {
        // Only allow 'equals' filtering for simplicity
        filterOptions: ['equals', 'lessThan', 'greaterThan'],
      },
      getQuickFilterText: params => {
        // Optional: for quick filter to work with length
        return params.value?.length?.toString() || "0";
      },
      cellRenderer: (params) => {
        if (params.node.group) {
          return null;
        }
        const emails = params.value; // Assuming params.value is an array of emails
        const visibleEmail = emails?.[0]; // Show only the first email
        const remainingCount = emails?.length > 1 ? emails.length - 1 : 0; // Count remaining emails

        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            {emails && Array.isArray(emails) && emails.length > 0 ? (
              <>
                <Tag icon={<MailOutlined />}>{visibleEmail}</Tag>

                {remainingCount > 0 && (
                  <Tooltip
                    title={emails.slice(1).map((email, idx) => (
                      <div key={idx}>{email}</div>
                    ))}
                  >
                    <span style={{ color: "#1890ff", cursor: "pointer" }}>
                      +{remainingCount}
                    </span>
                  </Tooltip>
                )}

                <EditFilled
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  onClick={() => props.openEmailModal(params.data)}
                />
              </>
            ) : (
              <Tag
                style={{ cursor: "pointer" }}
                onClick={() => props.openEmailModal(params.data)}
              >
                Add Email
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Invalid Hotel Contact Email",
      field: "email_hotel_contact_invalid_email",
      enableRowGroup: true,
      width: 300,
      filter: "agTextColumnFilter",
     
    },
    {
      headerName: "Pincode",
      field: "pincode",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      editable: true,
    },
    {
      headerName: "Hotel Name",
      field: "email_hotel_name",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      // checkboxSelection: true,
      editable: true,
    },
    {
      headerName: "City",
      field: "email_hotel_city",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      editable: true,
    },
    {
      headerName: "Hotel Contact Number",
      field: "email_hotel_contact_phone",
      width: 300,
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        if (params.node.group) {
          return null;
        }
        const phoneNumbers = params.value; // Assuming it's an array of phone numbers
        const visiblePhone = phoneNumbers?.[0]; // Show only the first phone number
        const remainingCount =
          phoneNumbers?.length > 1 ? phoneNumbers.length - 1 : 0; // Count remaining numbers

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flexWrap: "wrap",
              overflow: "hidden",
              maxWidth: "100%",
            }}
          >
            {phoneNumbers &&
              Array.isArray(phoneNumbers) &&
              phoneNumbers.length > 0 ? (
              <>
                <Tag icon={<PhoneOutlined />}>{visiblePhone}</Tag>

                {remainingCount > 0 && (
                  <Tooltip
                    title={phoneNumbers.slice(1).map((phone, idx) => (
                      <div key={idx}>{phone}</div>
                    ))}
                  >
                    <span style={{ color: "#1890ff", cursor: "pointer" }}>
                      +{remainingCount}
                    </span>
                  </Tooltip>
                )}

                <EditFilled
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  onClick={() => props?.openPhoneModal(params.data)}
                />
              </>
            ) : (
              <Tag
                style={{ cursor: "pointer" }}
                onClick={() => props?.openPhoneModal(params.data)}
              >
                Add Phone
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      headerName: "Hotel GSTIN",
      field: "email_hotel_gstin",
      editable: true,
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },


    {
      headerName: "GST Amount",
      field: "totalGST",
      fiter: "agNumberColumnFilter",
      // enableRowGroup: true,
      // filter: "agNumberColumnFilter",
      // valueFormatter: (params) => {
      //   const value = params.value;
      //   return value == null || value === "" ? "-" : value;
      // },
      // cellRenderer: (params) => {
      //   if (params.node.group || !params.data) return null;

      //   const value = params.value;
      //   return value == null || value === "" ? "-" : value;
      // },
    },

    {
      headerName: "Traveller Info",

      field: "email_travellers_info",
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        return (
          <div style={{ height: "100%", width: "100%" }}>
            {(params.data?.email_travellers_info || []).map((item, key) => {
              return <Tag key={key}>{item.name}</Tag>;
            })}
          </div>
        );
      },
    },
    {
      headerName: "Hotel Address",
      field: "email_hotel_address",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      editable: true,
    },

    {
      headerName: "State",
      field: "email_hotel_state",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
    },

    // {
    //   headerName: "Check-in Date",
    //   field: "email_checkindate",
    //   filter: "agDateColumnFilter",
    //   enableRowGroup: true,
    //   valueFormatter: (params) => {
    //     if (!params.value) return "";
    //     const date = new Date(params.value);
    //     return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
    //   },
    // },
    {
      headerName: "Check-in Date",
      field: "email_checkindate",
      filter: "agDateColumnFilter",
      enableRowGroup: true,

      valueFormatter: (params) => {
        if (!params.value) return "";

        let date;

        // Case 1: DD-MM-YYYY format
        if (/^\d{2}-\d{2}-\d{4}$/.test(params.value)) {
          const [day, month, year] = params.value.split("-");
          date = new Date(`${year}-${month}-${day}`);
        }
        // Case 2: ISO date string
        else {
          date = new Date(params.value);
        }

        if (isNaN(date.getTime())) return "Invalid Date";

        return date.toLocaleDateString("en-GB"); // Always show dd/mm/yyyy
      },

      filterParams: {
        comparator: (filterDate, cellValue) => {
          if (!cellValue) return -1;

          let date;

          // Case 1: DD-MM-YYYY
          if (/^\d{2}-\d{2}-\d{4}$/.test(cellValue)) {
            const [day, month, year] = cellValue.split("-");
            date = new Date(`${year}-${month}-${day}`);
          }
          // Case 2: ISO string
          else {
            date = new Date(cellValue);
          }

          if (isNaN(date.getTime())) return -1;

          if (date < filterDate) return -1;
          if (date > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: "Booking Date",
      field: "email_bookingdate",
      filter: "agDateColumnFilter",
      enableRowGroup: true,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
      },
    },
    // {
    //   headerName: "Check-out Date",
    //   field: "email_checkoutdate",
    //   filter: "agDateColumnFilter",
    //   enableRowGroup: true,
    //   valueFormatter: (params) => {
    //     if (!params.value) return "";
    //     const date = new Date(params.value);
    //     return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
    //   },
    // },
    {
      headerName: "Check-out Date",
      field: "email_checkoutdate",
      filter: "agDateColumnFilter",
      enableRowGroup: true,

      valueFormatter: (params) => {
        if (!params.value) return "";

        let date;

        // Case 1: DD-MM-YYYY
        if (/^\d{2}-\d{2}-\d{4}$/.test(params.value)) {
          const [day, month, year] = params.value.split("-");
          date = new Date(`${year}-${month}-${day}`);
        }
        // Case 2: ISO string (e.g., 2025-09-20T11:00:00+05:30)
        else {
          date = new Date(params.value);
        }

        if (isNaN(date.getTime())) return "Invalid Date";

        return date.toLocaleDateString("en-GB"); // dd/mm/yyyy
      },

      filterParams: {
        comparator: (filterDate, cellValue) => {
          if (!cellValue) return -1;

          let date;

          // Case 1: DD-MM-YYYY
          if (/^\d{2}-\d{2}-\d{4}$/.test(cellValue)) {
            const [day, month, year] = cellValue.split("-");
            date = new Date(`${year}-${month}-${day}`);
          }
          // Case 2: ISO string
          else {
            date = new Date(cellValue);
          }

          if (isNaN(date.getTime())) return -1;

          if (date < filterDate) return -1;
          if (date > filterDate) return 1;
          return 0;
        },
      },
    },



    {
      headerName: "Current Followup Stage",
      field: "last_mail_type",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Last Email Sent",
      field: "last_mail_sent_at",
      enableRowGroup: true,
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
      },
    },

    {
      headerName: "Email Logs",
      field: "email_logs",
      enableRowGroup: true,
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;

        return handleRenderEmailEvents(params.value);
      },
    },

    {
      headerName: "Action",
      enableRowGroup: true,
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;

        return (
          <Button icon={<MailOutlined />} size="small" onClick={() => {
            if (props.openResendModal) {
              props.openResendModal(params.data);
            }
          }}>
            Send Single Mail
          </Button>
        );
      },
    },

    {
      headerName: "View Invoice",
      field: "invoice_link_new",
      cellRenderer: (params) => {
        let links = [];

        if (typeof params.value === "string") {
          links = params.value
            .split(",")
            .map((link) => link.trim())
            .filter((link) => !!link);
        } else if (Array.isArray(params.value)) {
          links = params.value
            .map((link) => (typeof link === "string" ? link.trim() : ""))
            .filter((link) => !!link);
        }

        const handleClick = () => {
          if (links.length > 0) {
            handleInvoiceView(links);
          }
        };

        return links.length > 0 ? (
          <span
            onClick={handleClick}
            style={{ cursor: "pointer", color: "blue" }}
          >
            View Invoice
          </span>
        ) : (
          <span style={{ color: "#888" }}>No Invoice</span>
        );
      },
    },

    {
      headerName: "Invoice Received Status",
      field: "invoiceStatus",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      // filterParams: {
      //   values: ['Invoice Received'],
      // },
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;
        const value = params.value;
        const isReceived = value === "Invoice Received";
        return (
          <Tag color={isReceived ? "green" : "red"}>
            {isReceived ? "Invoice Received" : "Invoice Not Received"}
          </Tag>
        );
      },
    },
    // {
    //   headerName: "GST Amount",
    //   field: "total_gst",
    //   filter: "agNumberColumnFilter",
    //   valueFormatter: (params) => {
    //     const value = params.value;
    //     return !value ? '-' : value;
    //   }
    // },


    {
      headerName: "GSTIN Match Status",
      field: "gstMatchStatus",
      enableRowGroup: true,
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["MATCH", "MISMATCH"],
      },
      cellRenderer: (params) => {
        const value = params.value?.toUpperCase();
        if (value === "MATCH") {
          return (
            <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
          );
        } else if (value === "MISMATCH") {
          return (
            <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
          );
        } else {
          return value || "";
        }
      },

    },
    // {
    //   headerName: "Follow Up Status",
    //   field: "followUpStatus",
    //   editable: true,
    //   cellEditor: 'agSelectCellEditor',
    //   cellEditorParams: {
    //     values: [
    //       'Invoice Received',
    //       'Not ready to share the invoice',
    //       'Need booking data',
    //       'Hotel closed'
    //     ],
    //   },
    //   cellRendererFramework: FollowUpStatusRenderer,
    //   onCellValueChanged: async (params) => {
    //     const email_bookingId = params.data.email_bookingId;
    //     const followUpStatus = params.newValue;

    //     try {
    //       const res = await fetch('http://localhost:7001/api/hotelFollowUp/updateFollowUpStatus', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ email_bookingId, followUpStatus }),
    //       });

    //       const result = await res.json();
    //       if (!res.ok) {
    //         console.warn("Update failed:", result.message);
    //       }
    //     } catch (err) {
    //       console.error("API error:", err);
    //     }
    //   }
    // }
      {
      headerName: "Follow Up Status",
      field: "followUpStatus",
      // editable: true,
      editable: (params) => {
        return !params.data._pendingStatus; // 👈 disable edit if pending change
      },
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: [
          '',
          'Invoice Received',
          'Not ready to share the invoice',
          'Need booking data',
          'Hotel closed'
        ],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [
          '',
          'Invoice Received',
          'Not ready to share the invoice',
          'Need booking data',
          'Hotel closed'
        ],
      },
      cellRenderer: (props) => {
        const { data, value, api, node, colDef } = props;
        const hasPending = data._pendingStatus !== undefined;
        const displayValue = hasPending ? data._pendingStatus : value || "Select status";
    
        const handleConfirm = async (e) => {
          e.stopPropagation(); // prevent AG Grid cell click
    
          try {
            const res = await fetch('https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/updateFollowUpStatus', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email_bookingId: data.email_bookingId,
                followUpStatus: data._pendingStatus,
              }),
            });
    
            const result = await res.json();
            if (res.ok) {
              data.followUpStatus = data._pendingStatus;
              delete data._pendingStatus;
              api.refreshCells({ rowNodes: [node], columns: [colDef.field] });
            } else {
              console.error("API failed:", result);
            }
          } catch (err) {
            console.error("API error:", err);
          }
        };
    
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: '100%' }}>
            <div style={{ color: !value && !hasPending ? '#aaa' : '#000' }}>
              {displayValue}
            </div>
            {hasPending && (
              <CheckCircleOutlined
                style={{ color: "green", cursor: "pointer", marginLeft: 8 }}
                onClick={handleConfirm}
              />
            )}
          </div>
        );
      },
      onCellValueChanged: (params) => {
        const { data, newValue, oldValue } = params;
        if (newValue !== oldValue) {
          data._pendingStatus = newValue;
          params.api.refreshCells({
            rowNodes: [params.node],
            columns: ['followUpStatus'],
            force: true,
          });
        }
      },
    },

  {
      headerName: "Remark 1",
      field: "remark1",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      editable: true,
    },
     {
      headerName: "Remark 2",
      field: "remark2",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      editable: true,
    },


  ];
};



export const AIRLINE_FOLLOWUP_COLUMN_DEFS = (props) => {
  return [
    {
      headerName: "Followup completed",
      field: "followup_completed",

    },
    {
      headerName: 'Tracking Id',
      field: 'trackingId',
      hide: true,
    },
    {
      headerName: 'Select',
      field: 'id', // or any key
      checkboxSelection: (params) => {
        // Only show checkbox for child rows under a group
        return !params.node.group && params.node.parent != null;
      },
      headerCheckboxSelection: false,
      width: 100,
      pinned: 'left',
    },
    {
      headerName: "Mail Config Status",
      field: "mailConfigStauts",
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["RUNNING", "EMAILREQUIRED"],
      },
      enableRowGroup: true,
      cellRenderer: (params) => {
        console.log("parmas:");
        if (params.node.group || !params?.data?.mailConfigStauts) return null;

        const status = params.data.mailConfigStauts;
        const color = status === "RUNNING" ? "green" : "red";

        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      headerName: "Booking ID/Invoice Number",
      field: "email_bookingId",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Booking Client ID",
      field: "booking_client_id",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },

    // {
    //   headerName: "Client Name",
    //   field: "company_name",
    //   filter: "agTextColumnFilter",
    //   enableRowGroup: true,
    //   // rowGroupIndex: 1, 
    // },
    {
      headerName: "Agency Name",
      field: "agency_name",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      // rowGroupIndex: 1,
    },
    {
      headerName: "Workspace",
      field: "company_name",
      enableRowGroup: true
    },
    {
      headerName: "Template",
      width: 200,
      cellRenderer: (params) => {
        if (params.node.group || !params.data) return null;

        return (
          <Button
            type="primary"
            onClick={() => {
              props.setModalType("TEMPLATE");
              props.setModalData(params.data);
              props.setIsModalVisible(true);
            }}
            size="small"
          >
            Show Template
          </Button>
        );
      },
    },

    {
      headerName: "Airline Contact Email",
      field: "email_hotel_contact_email",
      enableRowGroup: true,
      width: 300,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        if (params.node.group) {
          return null;
        }
        const emails = params.value; // Assuming params.value is an array of emails
        const visibleEmail = emails?.[0]; // Show only the first email
        const remainingCount = emails?.length > 1 ? emails.length - 1 : 0; // Count remaining emails

        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            {emails && Array.isArray(emails) && emails.length > 0 ? (
              <>
                <Tag icon={<MailOutlined />}>{visibleEmail}</Tag>

                {remainingCount > 0 && (
                  <Tooltip
                    title={emails.slice(1).map((email, idx) => (
                      <div key={idx}>{email}</div>
                    ))}
                  >
                    <span style={{ color: "#1890ff", cursor: "pointer" }}>
                      +{remainingCount}
                    </span>
                  </Tooltip>
                )}

                <EditFilled
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  onClick={() => props.openEmailModal(params.data)}
                />
              </>
            ) : (
              <Tag
                style={{ cursor: "pointer" }}
                onClick={() => props.openEmailModal(params.data)}
              >
                Add Email
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      headerName: "SSR Email",
      field: "stuck_email_address",
      enableRowGroup: true,
      filter: 'agTextColumnFilter'
    },
    {
      headerName: "Airline Name",
      field: "airline_name",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
      CheckBoxSelection: true
      // rowGroupIndex: 0,


    },
    {
      headerName: "GST Amount",
      field: "totalGST",
      filter: "agNumberColumnFilter",
      // enableRowGroup: true,
      // filter: "agNumberColumnFilter",
      // valueFormatter: (params) => {
      //   const value = params.value;
      //   return value == null || value === "" ? "-" : value;
      // },
      // cellRenderer: (params) => {
      //   if (params.node.group || !params.data) return null;

      //   const value = params.value;
      //   return value == null || value === "" ? "-" : value;
      // },
    },
    // {
    //   headerName: "Transaction Date",
    //   field: "transaction_date",
    //   filter: "agDateColumnFilter",
    //   enableRowGroup: true,
    //   valueFormatter: (params) => {
    //     if (!params.value) return "";
    //     const date = new Date(params.value);
    //     return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
    //   },
    // },
    {
      headerName: "Transaction Date",
      field: "transaction_date",
      filter: "agDateColumnFilter",
      enableRowGroup: true,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);

        if (isNaN(date.getTime())) return params.value; // Handle invalid date safely

        return date.toLocaleDateString("en-GB"); // ✅ dd/mm/yyyy
      },
    },
    {
      headerName: "Invoice/Travel Date",
      field: "invoice_date",
      filter: "agDateColumnFilter",
      enableRowGroup: true,
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
      },
    },

    {
      headerName: "Current Followup Stage",
      field: "last_mail_type",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Last Email Sent",
      field: "last_mail_sent_at",
      enableRowGroup: true,
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
      },
    },

    {
      headerName: "Email Logs",
      field: "email_logs",
      enableRowGroup: true,
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;

        return handleRenderEmailEvents(params.value);
      },
    },

    {
      headerName: "Action",
      enableRowGroup: true,
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;

        return (
          <Button icon={<MailOutlined />} size="small" onClick={() => {
            console.log('Resend Mail row data:', params.data);
          }}>
            Send Next Followup Mail
          </Button>
        );
      },
    },


    {
      headerName: "View Invoice",
      field: "invoice_link_new",
      cellRenderer: (params) => {
        let links = [];

        if (typeof params.value === "string") {
          links = params.value
            .split(",")
            .map((link) => link.trim())
            .filter((link) => !!link);
        } else if (Array.isArray(params.value)) {
          links = params.value
            .map((link) => (typeof link === "string" ? link.trim() : ""))
            .filter((link) => !!link);
        }

        const handleClick = () => {
          if (links.length > 0) {
            handleInvoiceView(links);
          }
        };

        return links.length > 0 ? (
          <span
            onClick={handleClick}
            style={{ cursor: "pointer", color: "blue" }}
          >
            View Invoice
          </span>
        ) : (
          <span style={{ color: "#888" }}>No Invoice</span>
        );
      },
    },
    {
      headerName: "User Reply",
      field: "userReply"

    },
    {
      headerName: "Reply Context",
      field: "replyContext",
      filter: "agSetColumnFilter",
      filterParams: {
        values: [
          "Ticket Created",
          "Invalid Booking Data",
          "Invoice Already Shared"
        ],
      },
      cellRenderer: (params) => {
        if (params.node.group || !params.value) return null;

        const value = params.value;
        let color = "default";

        switch (value) {
          case "Ticket Created":
            color = "gold"; // yellow
            break;
          case "Invalid Booking Data":
            color = "red";
            break;
          case "Invoice Already Shared":
            color = "blue";
            break;
          default:
            color = "default"; // fallback for unknown values
        }

        return <Tag color={color}>{value}</Tag>;
      },


    },
    {
      headerName: "Reply At",
      field: "reply_at",
      filter: "agDateColumnFilter",
      enableRowGroup: true,

      valueFormatter: (params) => {
        if (!params.value) return "";

        let date;

        // Case 1: DD-MM-YYYY
        if (/^\d{2}-\d{2}-\d{4}$/.test(params.value)) {
          const [day, month, year] = params.value.split("-");
          date = new Date(`${year}-${month}-${day}`);
        }
        // Case 2: ISO string (e.g., 2025-09-20T11:00:00+05:30)
        else {
          date = new Date(params.value);
        }

        if (isNaN(date.getTime())) return "Invalid Date";

        return date.toLocaleDateString("en-GB"); // dd/mm/yyyy
      },

      filterParams: {
        comparator: (filterDate, cellValue) => {
          if (!cellValue) return -1;

          let date;

          // Case 1: DD-MM-YYYY
          if (/^\d{2}-\d{2}-\d{4}$/.test(cellValue)) {
            const [day, month, year] = cellValue.split("-");
            date = new Date(`${year}-${month}-${day}`);
          }
          // Case 2: ISO string
          else {
            date = new Date(cellValue);
          }

          if (isNaN(date.getTime())) return -1;

          if (date < filterDate) return -1;
          if (date > filterDate) return 1;
          return 0;
        },
      },
    },
    {
      headerName: "Invoice Received Status",
      field: "invoiceStatus",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      // filterParams: {
      //   values: ['Invoice Received'],
      // },
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;
        const value = params.value;
        const isReceived = value === "Invoice Received";
        return (
          <Tag color={isReceived ? "green" : "red"}>
            {isReceived ? "Invoice Received" : "Invoice Not Received"}
          </Tag>
        );
      },
    },
    // {
    //   headerName: "GST Amount",
    //   field: "total_gst",
    //   filter: "agNumberColumnFilter",
    //   valueFormatter: (params) => {
    //     const value = params.value;
    //     return !value ? '-' : value;
    //   }
    // },


    {
      headerName: "GSTIN Match Status",
      field: "gstMatchStatus",
      enableRowGroup: true,
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["MATCH", "MISMATCH"],
      },
      cellRenderer: (params) => {
        const value = params.value?.toUpperCase();
        if (value === "MATCH") {
          return (
            <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
          );
        } else if (value === "MISMATCH") {
          return (
            <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
          );
        } else {
          return value || "";
        }
      },
    },
    {
      headerName: "Follow Up Status",
      field: "followUpStatus",
      editable: true,
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: [
          '',
          'Invoice Received',
          'Not ready to share the invoice',
          'Need booking data',
          'Hotel closed'
        ],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [
          '', // represents "Select status" or blank
          'Invoice Received',
          'Not ready to share the invoice',
          'Need booking data',
          'Hotel closed'
        ],

      },
      cellRenderer: (props) => {
        const { data, value, api, node, colDef } = props;

        const hasPending = data._pendingStatus !== undefined;

        const handleConfirm = async () => {
          const email_bookingId = data.email_bookingId;
          const followUpStatus = data._pendingStatus;

          try {
            const res = await fetch('https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/updateFollowUpStatus', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email_bookingId, followUpStatus }),
            });

            const result = await res.json();

            if (res.ok) {
              data.followUpStatus = followUpStatus;
              delete data._pendingStatus;
              api.refreshCells({ rowNodes: [node], columns: [colDef.field] });
            }
          } catch (err) {
            console.error("API error:", err);
          }
        };

        const handleCancel = () => {
          delete data._pendingStatus;
          api.refreshCells({ rowNodes: [node], columns: [colDef.field] });
        };

        const displayValue = hasPending ? data._pendingStatus : value || "Select status";

        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: '100%' }}>
            <div style={{ color: !value ? '#aaa' : '#000' }}>{displayValue}</div>
            {hasPending && (
              <>
                <div style={{ color: "grey", cursor: "pointer" }} onClick={handleConfirm}><CheckCircleOutlined /></div>
              </>
            )}
          </div>
        );
      },
      onCellValueChanged: (params) => {
        const { data, newValue, oldValue } = params;
        if (newValue !== oldValue) {
          data._pendingStatus = newValue;
          data.followUpStatus = oldValue; // Temporarily revert
          params.api.refreshCells({ rowNodes: [params.node], columns: ['followUpStatus'] });
        }
      }
    }




  ];
};


export const CLIENT_FOLLOWUP_COLUMN_DEFS = (props) => {
  return [
    {
      headerName: 'Tracking Id',
      field: 'trackingId',
      hide: true,
    },
    {
      headerName: 'Select',
      field: 'id', // or any key
      checkboxSelection: (params) => {
        // Only show checkbox for child rows under a group
        return !params.node.group && params.node.parent != null;
      },
      headerCheckboxSelection: false,
      width: 100,
      pinned: 'left',
    },
    {
      headerName: "contactName",
      field: "contactName"
    },
    {
      headerName: "Mail Config Status",
      field: "mailConfigStauts",
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["RUNNING", "EMAILREQUIRED"],
      },
      enableRowGroup: true,
      cellRenderer: (params) => {
        console.log("parmas:");
        if (params.node.group || !params?.data?.mailConfigStauts) return null;

        const status = params.data.mailConfigStauts;
        const color = status === "RUNNING" ? "green" : "red";

        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      headerName: "Booking ID",
      field: "email_bookingId",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },
    {
      headerName: "Booking Client ID",
      field: "booking_client_id",
      filter: "agTextColumnFilter",
      enableRowGroup: true,
    },

    // {
    //   headerName: "Client Name",
    //   field: "company_name",
    //   filter: "agTextColumnFilter",
    //   enableRowGroup: true,
    //   // rowGroupIndex: 1, 
    // },

    {
      headerName: "Workspace",
      field: "company_name",
      enableRowGroup: true
    },
    {
      headerName: "Template",
      width: 200,
      cellRenderer: (params) => {
        if (params.node.group || !params.data) return null;

        return (
          <Button
            type="primary"
            onClick={() => {
              props.setModalType("TEMPLATE");
              props.setModalData(params.data);
              props.setIsModalVisible(true);
            }}
            size="small"
          >
            Show Template
          </Button>
        );
      },
    },

    {
      headerName: "Client Contact Email",
      field: "email_hotel_contact_email",
      enableRowGroup: true,
      width: 300,
      filter: "agTextColumnFilter",
      cellRenderer: (params) => {
        if (params.node.group) {
          return null;
        }
        const emails = params.value; // Assuming params.value is an array of emails
        const visibleEmail = emails?.[0]; // Show only the first email
        const remainingCount = emails?.length > 1 ? emails.length - 1 : 0; // Count remaining emails

        return (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flexWrap: "wrap",
            }}
          >
            {emails && Array.isArray(emails) && emails.length > 0 ? (
              <>
                <Tag icon={<MailOutlined />}>{visibleEmail}</Tag>

                {remainingCount > 0 && (
                  <Tooltip
                    title={emails.slice(1).map((email, idx) => (
                      <div key={idx}>{email}</div>
                    ))}
                  >
                    <span style={{ color: "#1890ff", cursor: "pointer" }}>
                      +{remainingCount}
                    </span>
                  </Tooltip>
                )}

                <EditFilled
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  onClick={() => props.openEmailModal(params.data)}
                />
              </>
            ) : (
              <Tag
                style={{ cursor: "pointer" }}
                onClick={() => props.openEmailModal(params.data)}
              >
                Add Email
              </Tag>
            )}
          </div>
        );
      },
    },
    {
      field: "totalAtRisk",
      headerName: 'TotalAtRisk'

    },
    {
      headernamwe: "Total K3",
      field: "totalK3"
    },
    {
      field: "totalReceived",
      headerName: "Total Received"
    },


    {
      headerName: "Current Followup Stage",
      field: "last_mail_type",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Last Email Sent",
      field: "last_mail_sent_at",
      enableRowGroup: true,
      filter: "agDateColumnFilter",
      valueFormatter: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);
        return date.toLocaleDateString("en-GB"); // Formats as "dd/mm/yyyy"
      },
    },

    {
      headerName: "Email Logs",
      field: "email_logs",
      enableRowGroup: true,
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;

        return handleRenderEmailEvents(params.value);
      },
    },

    {
      headerName: "Action",
      enableRowGroup: true,
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;

        return (
          <Button icon={<MailOutlined />} size="small" onClick={() => {
            console.log('Resend Mail row data:', params.data);
          }}>
            Send Next Followup Mail
          </Button>
        );
      },
    },


    {
      headerName: "View Invoice",
      field: "invoice_link_new",
      cellRenderer: (params) => {
        let links = [];

        if (typeof params.value === "string") {
          links = params.value
            .split(",")
            .map((link) => link.trim())
            .filter((link) => !!link);
        } else if (Array.isArray(params.value)) {
          links = params.value
            .map((link) => (typeof link === "string" ? link.trim() : ""))
            .filter((link) => !!link);
        }

        const handleClick = () => {
          if (links.length > 0) {
            handleInvoiceView(links);
          }
        };

        return links.length > 0 ? (
          <span
            onClick={handleClick}
            style={{ cursor: "pointer", color: "blue" }}
          >
            View Invoice
          </span>
        ) : (
          <span style={{ color: "#888" }}>No Invoice</span>
        );
      },
    },

    {
      headerName: "Invoice Received Status",
      field: "invoiceStatus",
      enableRowGroup: true,
      filter: "agTextColumnFilter",
      // filterParams: {
      //   values: ['Invoice Received'],
      // },
      cellRenderer: (params) => {
        if (params.node.group || params.value === "") return null;
        const value = params.value;
        const isReceived = value === "Invoice Received";
        return (
          <Tag color={isReceived ? "green" : "red"}>
            {isReceived ? "Invoice Received" : "Invoice Not Received"}
          </Tag>
        );
      },
    },
    // {
    //   headerName: "GST Amount",
    //   field: "total_gst",
    //   filter: "agNumberColumnFilter",
    //   valueFormatter: (params) => {
    //     const value = params.value;
    //     return !value ? '-' : value;
    //   }
    // },
    {
      headerName: "GST Amount",
      field: "totalGST",
      filter: "agNumberColumnFilter",
      // enableRowGroup: true,
      // filter: "agNumberColumnFilter",
      // valueFormatter: (params) => {
      //   const value = params.value;
      //   return value == null || value === "" ? "-" : value;
      // },
      // cellRenderer: (params) => {
      //   if (params.node.group || !params.data) return null;

      //   const value = params.value;
      //   return value == null || value === "" ? "-" : value;
      // },
    },

    {
      headerName: "GSTIN Match Status",
      field: "gstMatchStatus",
      enableRowGroup: true,
      filter: "agSetColumnFilter",
      filterParams: {
        values: ["MATCH", "MISMATCH"],
      },
      cellRenderer: (params) => {
        const value = params.value?.toUpperCase();
        if (value === "MATCH") {
          return (
            <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
          );
        } else if (value === "MISMATCH") {
          return (
            <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
          );
        } else {
          return value || "";
        }
      },
    },
    {
      headerName: "Email should be sent",
      field: "emailShouldBeSent", // new field name
      // editable: true,
      editable: (params) => {
        return !params.data._pendingEmailStatus; // 👈 disable edit if pending change
      },
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: [
          " ", // optional initial blank
          'Yes, Send the mail',
          "No, don't send the mail"
        ],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [
          " ",
          'Yes, Send the mail',
          "No, don't send the mail"
        ],
      },
      cellRenderer: (props) => {
        const { data, value, api, node, colDef } = props;

        const hasPending = data._pendingEmailStatus !== undefined;
        console.log(hasPending, "has pending inside email should be sent")

        const handleConfirm = async () => {
          console.log("Inside confirm function")
          console.log(data, "data to be check")
          const email_bookingId = data.email_bookingId;
          const emailShouldBeSent = data._pendingEmailStatus ?? '';

          try {
            const res = await fetch('https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/updateFollowUpStatus', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email_bookingId, emailShouldBeSent }),
            });

            const result = await res.json();

            if (res.ok) {
              data.emailShouldBeSent = emailShouldBeSent;
              delete data._pendingEmailStatus;
              api.refreshCells({ rowNodes: [node], columns: [colDef.field] });
              api.redrawRows({ rowNodes: [node] });
              
            }
          } catch (err) {
            console.error("API error:", err);
          }
        };

        const handleCancel = () => {
          delete data._pendingEmailStatus;
          api.refreshCells({ rowNodes: [node], columns: [colDef.field] });
        };

        const displayValue = hasPending ? data._pendingEmailStatus : value || "Select option";
        console.log(hasPending, "hasPending")

        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: '100%' }}>
            <div style={{ color: !value ? '#aaa' : '#000' }}>{displayValue}</div>
            {hasPending && (
              <div
                style={{ color: "green", cursor: "pointer" }}
                onClick={(e) => {
                  e.preventDefault();      // prevent AG Grid's internal cell edit behavior
                  e.stopPropagation();     // stop grid from swallowing the click
                  handleConfirm();         // your actual API call
                }}
              >
                <CheckCircleOutlined />
              </div>
            )}
          </div>
        );
      },
      onCellValueChanged: (params) => {
        const { data, newValue, oldValue } = params;
        
  if (newValue !== oldValue || (newValue === " " && oldValue)) { {
          data._pendingEmailStatus = newValue;
          // data.emailShouldBeSent = oldValue; // Temporarily revert
          params.api.refreshCells({ rowNodes: [params.node], columns: ['emailShouldBeSent'],  force: true, });
        }
      }
    },
  },

    
    
    
    {
      headerName: "Follow Up Status",
      field: "followUpStatus",
      // editable: true,
      editable: (params) => {
        return !params.data._pendingStatus; // 👈 disable edit if pending change
      },
      cellEditor: 'agSelectCellEditor',
      cellEditorParams: {
        values: [
          '',
          'Invoice Received',
          'Not ready to share the invoice',
          'Need booking data',
          'Hotel closed'
        ],
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        values: [
          '',
          'Invoice Received',
          'Not ready to share the invoice',
          'Need booking data',
          'Hotel closed'
        ],
      },
      cellRenderer: (props) => {
        const { data, value, api, node, colDef } = props;
        const hasPending = data._pendingStatus !== undefined;
        const displayValue = hasPending ? data._pendingStatus : value || "Select status";
    
        const handleConfirm = async (e) => {
          e.stopPropagation(); // prevent AG Grid cell click
    
          try {
            const res = await fetch('https://stage-apiplatform.finkraftai.com/api/hotelFollowUp/updateFollowUpStatus', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                email_bookingId: data.email_bookingId,
                followUpStatus: data._pendingStatus,
              }),
            });
    
            const result = await res.json();
            if (res.ok) {
              data.followUpStatus = data._pendingStatus;
              delete data._pendingStatus;
              api.refreshCells({ rowNodes: [node], columns: [colDef.field] });
            } else {
              console.error("API failed:", result);
            }
          } catch (err) {
            console.error("API error:", err);
          }
        };
    
        return (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: '100%' }}>
            <div style={{ color: !value && !hasPending ? '#aaa' : '#000' }}>
              {displayValue}
            </div>
            {hasPending && (
              <CheckCircleOutlined
                style={{ color: "green", cursor: "pointer", marginLeft: 8 }}
                onClick={handleConfirm}
              />
            )}
          </div>
        );
      },
      onCellValueChanged: (params) => {
        const { data, newValue, oldValue } = params;
        if (newValue !== oldValue) {
          data._pendingStatus = newValue;
          params.api.refreshCells({
            rowNodes: [params.node],
            columns: ['followUpStatus'],
            force: true,
          });
        }
      },
    }
    




  ];
};
